import { faMinus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const emptyCell = (
  <div className="text-center">
    <FontAwesomeIcon icon={faMinus} style={{ color: 'var(--surface-400)' }} />
  </div>
);
